import * as React from 'react';

import { useAtom, useAtomValue, useSetAtom } from 'jotai';

import { useCoreRoleCreateMutation } from './_graphql/useCoreRoleCreateMutation';

import { AddRoleDialogBase } from '~/modules/settings/_components/_shared';
import { allPermissionModules } from '~/modules/settings/_generated/permissions';
import {
  $addRoleDialogOpen,
  $addRoleFormData,
  $addRoleFormValid,
  $closeAddRoleDialog,
  $updateAddRoleForm,
} from '~/modules/settings/_state/addRoleDialog.state';
import { useTranslations } from '~/modules/settings/i18n/useTranslations';

export const AddRoleDialog = () => {
  const t = useTranslations();

  const [isOpen] = useAtom($addRoleDialogOpen);
  const formData = useAtomValue($addRoleFormData);
  const isFormValid = useAtomValue($addRoleFormValid);
  const updateForm = useSetAtom($updateAddRoleForm);
  const closeDialog = useSetAtom($closeAddRoleDialog);

  const { mutateAsync: createRole, isPending } = useCoreRoleCreateMutation();

  const handlePermissionChange = React.useCallback(
    (key: string, enabled: boolean) => {
      updateForm({
        permissions: { ...formData.permissions, [key]: enabled },
      });
    },
    [formData.permissions, updateForm],
  );

  const handleBulkPermissionChange = React.useCallback(
    (changes: Record<string, boolean>) => {
      updateForm({
        permissions: { ...formData.permissions, ...changes },
      });
    },
    [formData.permissions, updateForm],
  );

  return (
    <AddRoleDialogBase
      isOpen={isOpen}
      formData={formData}
      isFormValid={isFormValid}
      onUpdateName={(name) => updateForm({ name })}
      onPermissionChange={handlePermissionChange}
      onBulkPermissionChange={handleBulkPermissionChange}
      onClose={closeDialog}
      createRole={createRole}
      isCreatePending={isPending}
      permissionModules={allPermissionModules}
      translations={t.teamAndPermissions.roles.addRoleDialog}
      className="@AddRoleDialog"
    />
  );
};
